import Constants from '../model/AppConfiguration';
import moment from 'moment';

export default { flightsIntToWire: flightsIntToWire };

function flightsIntToWire (request, general, intFlights) {
  switch (request) {
    case Constants.REQUEST.FLIGHTS:
      return submitFlights(general, intFlights);
    case Constants.REQUEST.PASSENGERS:
      return submitPassengers(general, intFlights);
    case Constants.REQUEST.SEATS:
      return submitSeats(general, intFlights);
    case Constants.REQUEST.MEALS:
      return submitMeals(general, intFlights);
    case Constants.REQUEST.REVIEW:
      return submitReview(general, intFlights);
    case Constants.REQUEST.ACTION.PRINT:
      return printAction(general);
    default:
      return coreFlights(general, intFlights);
  }
}

function coreFlights (general, intFlights) {
  const { action, reservationId, passengerId, trip } = general;

  let core = {
    result: {
      action: action,
      reservationid: reservationId || 44065,
      contact_objectid: passengerId || 4646,
      flights: intFlights,
    },
  };

  if (trip && trip.id) {
    core.result.tripType = intTripToWireTrip(trip);

    if (trip.id === Constants.flights.oneWay && intFlights > 1) {
      core.result.flights = [ intFlights[ 0 ] ];
    }
  }

  return core;
}

function coreFlightToWire (intFlight, general) {
  let { adults, infants, id, routeId, date } = intFlight;
  let wireFlight = {
    _attributes: {
      flightid: id,
      routeid: routeId,
    },
  };

  if (adults || adults === 0) {
    wireFlight._attributes.adults = adults;
  }

  if (infants || infants === 0) {
    wireFlight._attributes.infants = infants;
  }

  if (general && general.trip && general.trip.id) {
    wireFlight._attributes.tripsegmentid = general.trip.id;
  }

  if (date) {
    wireFlight._attributes.date = moment(date, Constants.DATE_FORMAT).format(
      Constants.SERVER_DATE_FORMAT
    );
  }

  return wireFlight;
}

function submitFlights (general, intFlights) {
  let wireFlights = [];
  for (let i = 0; i < intFlights.length; i++) {
    let flight = coreFlightToWire(intFlights[ i ], general);

    wireFlights.push({ flight });
  }

  return coreFlights(general, wireFlights);
}

function submitPassengers (general, intFlights) {
  let wireFlights = [];
  for (let i = 0; i < intFlights.length; i++) {
    let intFlight = intFlights[ i ];
    let flight = coreFlightToWire(intFlight, general);
    flight.contacts = intFlightPassengersToWire(intFlight.passengers);
    wireFlights.push({ flight });
  }
  return coreFlights(general, wireFlights);
}

function submitSeats (general, intFlights) {
  let wireFlights = [];
  for (let i = 0; i < intFlights.length; i++) {
    let intFlight = intFlights[ i ];
    let flight = coreFlightToWire(intFlight, general);
    flight.contacts = intFlightPassengersToWire(intFlight.passengers);
    wireFlights.push({ flight });
  }
  return coreFlights(general, wireFlights);
}

function submitMeals (general, intFlights) {
  let wireFlights = [];
  for (let i = 0; i < intFlights.length; i++) {
    let intFlight = intFlights[ i ];
    let flight = coreFlightToWire(intFlight, general);
    flight.contacts = intFlightPassengersToWire(intFlight.passengers, intFlight.selectedMeals);
    wireFlights.push({ flight });
  }
  return coreFlights(general, wireFlights);
}

function submitReview (general, intFlights) {
  let wireFlights = [];
  for (let i = 0; i < intFlights.length; i++) {
    let intFlight = intFlights[ i ];
    let flight = coreFlightToWire(intFlight, general);
    flight.contacts = intFlightPassengersToWire(intFlight.passengers);
    wireFlights.push({ flight });
  }
  return coreFlights(general, wireFlights);
}

function printAction (general) {
  const { reservationId } = general;

  return {
    result: {
      action: Constants.REQUEST.ACTION.PRINT,
      reservationid: reservationId || 44065,
    },
  };
}

function flightIntToWire (intFlight) {
  const { adults, infants, id, routeId, date, passengers, seats, meals, selectedMeals } = intFlight;
  return {
    _attributes: {
      adults: adults,
      infants: infants,
      flightid: id,
      routeid: routeId,
      date: moment(date).format(Constants.SERVER_DATE_FORMAT),
    },
    contacts: {
      contact: [
        {
          _attributes: {
            contact_objectid: '4646',
            FlightSeatID: '150153',
            SeatAssignmentID: '172076',
            selected: true,
          },
        },
        {
          _attributes: {
            contact_objectid: '11627',
            FlightSeatID: '150155',
            SeatAssignmentID: '172077',
            selected: true,
          },
        },
      ],
    },
  };
}

function intFlightPassengersToWire (intPassengers, selectedMeals) {
  if (!intPassengers || !intPassengers.length) {
    return { contact: [] };
  }
  let wirePassengers = [];
  for (let i = 0; i < intPassengers.length; i++) {
    wirePassengers.push(intFlightPassengerToWire(intPassengers[ i ], selectedMeals));
  }
  return { contact: wirePassengers };
}

function intFlightPassengerToWire (intPassenger, selectedMeals) {
  const { id, selected, seatId, seatAssignmentId } = intPassenger;
  let contact = {
    _attributes: {
      contact_objectid: id,
      selected,
      SeatAssignmentID: seatAssignmentId || '',
      FlightSeatID: seatId || '',
    },
  };

  if (selectedMeals && selectedMeals.length) {
    let selectedMeal = selectedMeals.find(passenger => passenger.id === id);

    if (selectedMeal) {
      contact.notes = selectedMeal.notes || '';

      let menuItems = [];
      let menuItemIds = '';
      let options = [];
      for (let i = 0; i < selectedMeal.meals.length; i++) {
        let mealItem = selectedMeal.meals[ i ];

        if (mealItem.id && parseInt(mealItem.id, 10)) {
          menuItemIds = menuItemIds ? `${menuItemIds},${mealItem.id}` : mealItem.id;
          menuItems.push({
            _attributes: {
              menuitemid: mealItem.id,
              selectedOptions: mealItem.description || '',
            },
          });

          if (mealItem.description) {
            options.push({
              _attributes: {
                MenuItemId: mealItem.id,
                selection: mealItem.description || '',
              },
            });
          }
        }
      }
      if (options && options.length) {
        contact.options = options;
      }
      contact.menuItems = menuItems;
      contact._attributes.MenuItemIDs = menuItemIds;
    }
  }

  return contact;
}

function intTripToWireTrip (trip) {
  const { id, label } = trip;
  return {
    _attributes: {
      numOfSegments: id,
      label,
    },
  };
}



// WEBPACK FOOTER //
// ./src/converter/IntFlightsConverter.js